import request from '@/utils/request'


export function queryRequest(data) {
  return request({
    url: '/db/acct-info/query',
    method: 'post',
    data
  })
}

export function hospModelAcctAdd(data) {
  return request({
    url: '/db/acct-info/add',
    method: 'post',
    data
  })
}

export function hospModelAdminAcctAdd(data) {
  return request({
    url: '/db/acct/admin-add',
    method: 'post',
    data
  })
}

export function deleteAcct(id){
  return request({
    url: '/db/acct-info/'+id,
    method: 'delete'
  })
}

export function hospUserInfoQuery(data) {
  return request({
    url: '/db/acct-info/hosp-user-info',
    method: 'post',
    data
  })
}

export function changeRole(data) {
  return request({
    url: '/db/acct/change-role',
    method: 'post',
    data
  })
}

export function updateAcctInfo(data) {
  return request({
    url: '/db/acct-info',
    method: 'put',
    data
  })
}